// Valid :subpage values for the /routes/:route_id/:subpage(/...) routes.
// Shared by the Route details tabs and by Route-level 404 validation in
// every component mounted under a :subpage route — keep in sync with the tabs.
export const ROUTE_SUBPAGES = ["overview", "provider", "destinations", "sources", "logs", "webhook", "configurations"] as const;

// An absent subpage is valid (it defaults to "overview" / doesn't apply).
export const isValidRouteSubpage = (subpage?: string): boolean =>
    !subpage
    || ROUTE_SUBPAGES.includes(subpage as typeof ROUTE_SUBPAGES[number]);

// The Route details page's tab strip and the floating section rail render the
// same three tabs — one list so they can't drift apart. Labels are i18n keys.
export const ROUTE_DETAIL_TABS = [
    { slug: "configurations", labelKey: "Configurations" },
    { slug: "sources", labelKey: "Sources" },
    { slug: "logs", labelKey: "Logs" },
] as const;

// Where a Route's tab lives. A Route has exactly three addresses — /routes/:id,
// /routes/:id/sources and /routes/:id/logs — because Configurations IS the bare
// URL and must not also have a segment of its own. Everything that navigates
// between tabs goes through here so that rule cannot be re-derived differently
// in one more place; /routes/:id/configurations still resolves, but only as a
// redirect for links minted before this rule.
export const routeTabPath = (routeId: string | undefined, tab?: string): string =>
    !tab || tab === "configurations" ? `/routes/${routeId}` : `/routes/${routeId}/${tab}`;
